/* eslint-disable react-hooks/exhaustive-deps */
import React, { useCallback, useEffect, useState } from 'react';
import { IPlaylist, IVideoPlaylistDetail } from '../../types';
import { objectToString } from './utils/helper';
import { USER_KEY_API, VIDEO_DATA_API } from './constants';
import fetchApi from '../../../../utils/fetchApi';
import { getClassNameFactory } from '@dcl/ui';
import { PlaylistTiles } from './PlaylistTiles';

export const PlayList: React.FC<IPlaylist> = (props: IPlaylist) => {
  const {
    partnerId,
    privileges,
    secretKey,
    subTitle,
    title,
    playlistEntryId,
  } = props;
  const [userKeyKs, setUserKeyKs] = useState<string>('');

  const [videoDetailData, setVideoDetailData] = useState<
    IVideoPlaylistDetail[]
  >();

  const initiateUserKeyApi = useCallback(async () => {
    const response = await fetchApi({
      baseHostUrl: USER_KEY_API,
      options: {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: objectToString({
          format: 1,
          type: 2,
          partnerId: Number(partnerId),
          secret: secretKey,
          privileges: privileges,
        }),
      },
    });

    const sessionKey = await response.text();
    setUserKeyKs(sessionKey.slice(1, -1));
  }, []);

  useEffect(() => {
    initiateUserKeyApi();
  }, [initiateUserKeyApi]);

  const initiateVideoDataApi = useCallback(async () => {
    const videoResponse = await fetchApi({
      baseHostUrl: VIDEO_DATA_API,
      options: {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          entryId: playlistEntryId,
          version: -1,
          format: 1,
          ks: userKeyKs,
        }),
      },
    });

    const videoMetaData = await videoResponse
      .text()
      .then((data) => JSON.parse(data));

    let videoData: IVideoPlaylistDetail[];
    if (videoMetaData.objectType === 'KalturaPlaylist') {
      const playlistContent = videoMetaData.playlistContent;
      videoData = playlistContent.split(',').map((entry: string) => {
        return {
          entryId: entry,
          videoFormat: 'Video',
        };
      });
      setVideoDetailData(videoData);
    }
  }, [userKeyKs]);

  useEffect(() => {
    initiateVideoDataApi();
  }, [initiateVideoDataApi]);

  const getClassName = getClassNameFactory(PlayList.displayName);

  return (
    <div className={getClassName()}>
      {videoDetailData && (
        <PlaylistTiles
          title={title}
          subTitle={subTitle}
          userKeyKs={userKeyKs}
          videoPlaylistDetails={videoDetailData}
        />
      )}
    </div>
  );
};

PlayList.displayName = 'PlayList';
